import Vue from 'vue'
import VueRouter from 'vue-router'
import PageRoutes from './pages'
import AccountRoutes from './account'
import SettlementRoutes from './settlement'
import Login from '../views/Login.vue'
import security from '@/services/security'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  PageRoutes,
  AccountRoutes,
  SettlementRoutes,
  {
    path: '/login',
    name: 'Login',
    component: Login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0, behavior: 'smooth' }
  }
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else if (to.path === '/oidc-code') {
    next()
    fetch(security.handleCodeRedirect(to.query))
      .then((res) => {
        return res.json()
      })
      .then((data) => {
        store.commit('security/SECURITY_SET_TOKEN', data)
        router.push('/')
      })
  } else if (!store.getters['security/isAuthenticated']) {
    next('/login')
  } else {
    next()
  }
})

export default router
